import React, { Component } from 'react';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState } from '../../../redux/store';
import { ChartState } from '../../../redux/reducers/ChartReducer';
import { PageState } from '../../../redux/reducers/PageReducer';
import {
  changeChart,
  changeChartEditorOptions,
  changeChartResponse,
  changeIsUpdate,
  clearChart,
  setExpressionVariables,
} from '../../../redux/actions/ChartActions';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AnimatedButton, ChartType } from '@trlogic/ui-pack';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import { repository } from '@trlogic/client-js';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { AuthState } from '../../../redux/reducers/AuthReducer';
import ChartUtil, { ChartUtilSettings } from '../../../util/ChartUtil';
import LegendOptionPanel from '../control-panel/options/LegendOptionPanel';
import LanguageUtil from '../../../util/LanguageUtil';

class ChartSettingsContainer extends Component<Props, State> {
  public state = new State();

  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  render() {
    const {
      chart: { chart },
      simulateChart,
    } = this.props;
    return (
      <div className={'flex flex-col lg:flex-row w-full xl:items-center items-end xl:justify-between  gap-y-5 gap-x-5 px-5 py-2'}>
        <div className={'flex xl:flex-row flex-col items-center gap-y-5 w-full gap-x-5 '}>
          <div className={'flex items-center w-full'}>
            <FormicaSearchSelectBox
              id={'formica-chart-dropdown'}
              value={chart.type as ChartType}
              rounded={true}
              onChange={this.onChangeChartType}
              placeholder={LanguageUtil.get({
                id: 'common.input.placeholder.selectChartType',
                defaultMessage: 'Select Chart Type',
              })}
              options={this.getChartTypeOptions()}
              icon={'chart'}
            />
          </div>
          {/* <div className={"flex items-center w-full"}>
            <FormicaSearchSelectBox id={"formica-text-dropdown"}
                                    value={chart.dataSource as string}
                                    onChange={(e) => this.onChangeActiveIndices(e.value as string)}
                                    placeholder={"Select an index"}
                                    rounded={true}
                                    onBlur={this.getAvailableTableVariables}
                                    options={this.getAccessibleIndices()} icon={"text"}/>

          </div>*/}
          <div className={'flex items-center w-full'}>{this.getChartOptions()}</div>
        </div>
        <div className={'flex xl:flex-row flex-col gap-y-5 w-full lg:w-1/2 h-full xl:w-full items-start xl:justify-end justify-start gap-x-5 '}>
          <div className={'flex items-center w-full xl:w-[430px]'}>
            {
              //<TimePickerContainer startDate={chartEditorOptions.startDate} endDate={chartEditorOptions.endDate} onChangeStartDate={this.setStartDate} onChangeEndDate={this.setEndDate}/>
            }
          </div>
          <AnimatedButton
            customType={'primary'}
            customSize={'md'}
            onClick={simulateChart}
            icon={'autoplay'}
            text={LanguageUtil.get({ id: 'common.button.refresh', defaultMessage: 'Refresh' })}
          />
        </div>
      </div>
    );
  }

  /* private getAccessibleIndices = () => {
     const {accessibleIndices} = this.props;
     return accessibleIndices.map((index) => ({label: index, value: index}));
   }
   public onChangeActiveIndices = async (index: string) => {
     const {chart: {chart}, changeChart, setData, setExpressionVariables} = this.props;
     chart.dataSource = index;
     setData(undefined);
     changeChart(chart);
     setExpressionVariables(await this.prepareVariables(chart.dataSource as string));
   }
   private prepareVariables = async (transaction: string): Promise<Record<string, TokenVariable[]>> => {
     const {chart: {chart}} = this.props;
     if (chart.dataSource == undefined) return {}
     const event: TransactionJsonModel | undefined = await this.repository.find(QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq("name", transaction)).build());
     if (event == undefined) return {}
     const eventVariables: any[] = event.variables.map(v => ({
       type: VariableType.EVENT_VARIABLE as any,
       variable: {
         type: "Common Variable",
         variableType: VariableType.EVENT_VARIABLE as any,
         properties: v.properties,
         name: v.name,
         args: {
           event: event.name
         }
       }
     }));
     eventVariables.push(...ChartValueFactory.initializeElasticVariables(this.props?.auth?.user?.activeRiskType as string))

     const enrichmentVariables: Record<Exclude<VariableType, VariableType.EVENT_VARIABLE | VariableType.ACTOR_VARIABLE | VariableType.STREAM_ROW_VARIABLE>, TokenVariable<VariableToken>[]> = _.groupBy((await this.repository.findMany(query.QueryBuilder.select().from(CollectionNames.ENRICHMENTS).build()) as EnrichmentBase[])
       .filter(e => e.type != VariableType.VELOCITY)
       .map(e => ({
         type: e.type,
         variable: {
           type: "Common Variable",
           variableType: e.type,
           name: e.name,
           properties: e.properties,
           args: {}
         }
       })), (e: any) => e.type) as Record<any, any[]>
     return {
       [VariableType.EVENT_VARIABLE]: eventVariables,
       ...enrichmentVariables,
     }
   }


   public getAvailableTableVariables = async () => {
     const {chart: {chartEditorOptions}, changeChartEditorOptions} = this.props;
     // chartEditorOptions.transactionVariables = await this.transactionService.getTableVariablesByTableName(chart.dataSource as string);
     changeChartEditorOptions(chartEditorOptions);
   }*/

  private simulateChart = () => {
    const {
      chart: { chart, chartEditorOptions },
      changeChart,
      simulateChart,
    } = this.props;
    const chartSettings: ChartUtilSettings = {
      name: chart.name || 'Test Chart',
      metrics: chartEditorOptions.metricItem,
      legendDisplay: true,
    };
    const options = ChartUtil.getChartOptionsByChartType(chart.type || ChartType.BAR_VERTICAL_ROWED, chartSettings);
    if (chart.visualOptions) {
      (chart.visualOptions as any)['plugins']['tooltip'] = options.plugins?.tooltip;
      chart.visualOptions.scales = options.scales;
      chart.visualOptions.indexAxis = options.indexAxis;
    } else {
      chart.visualOptions = options;
    }
    changeChart(chart);
    simulateChart();
  };
  private setChartType = (value: ChartType) => {
    const {
      chart: { chart, chartEditorOptions },
      changeChart,
    } = this.props;
    chart.type = value;

    const chartSettings: ChartUtilSettings = {
      name: chart.name || LanguageUtil.get({ id: 'common.label.testChart', defaultMessage: 'Test Chart' }),
      metrics: chartEditorOptions.metricItem,
      legendDisplay: true,
    };
    const options = ChartUtil.getChartOptionsByChartType(value, chartSettings);
    if (chart.visualOptions) {
      (chart.visualOptions as any)['plugins']['tooltip'] = options.plugins?.tooltip;
      chart.visualOptions.scales = options.scales;
      chart.visualOptions.indexAxis = options.indexAxis;
    } else {
      chart.visualOptions = options;
    }

    changeChart(chart);
    this.updateChartDataColors(value);
  };

  private updateChartDataColors = (chartType: ChartType) => {
    const {
      chart: { chartEditorOptions, chartResponse },
      changeChartResponse,
    } = this.props;
    if (chartResponse) {
      const _dataset = ChartUtil.setColorPalette(chartEditorOptions, chartResponse, chartType);
      changeChartResponse(_dataset);
    }
  };

  private getChartTypeOptions = () => {
    return [
      { label: LanguageUtil.get({ id: 'common.label.tableChart', defaultMessage: 'Table Chart' }), value: ChartType.TABLE, icon: 'table' },
      { label: LanguageUtil.get({ id: 'common.label.areaChart', defaultMessage: 'Area Chart' }), value: ChartType.AREA, icon: 'area-chart' },
      {
        label: LanguageUtil.get({ id: 'common.label.areaStackedChart', defaultMessage: 'Area Stacked Chard' }),
        value: ChartType.AREA_STACKED,
        icon: 'area-chart',
      },
      { label: LanguageUtil.get({ id: 'common.label.lineChart', defaultMessage: 'Line Chart' }), value: ChartType.LINE, icon: 'line-chart' },
      { label: LanguageUtil.get({ id: 'common.label.pieChart', defaultMessage: 'Pie Chart' }), value: ChartType.PIE, icon: 'pie-chart' },
      { label: LanguageUtil.get({ id: 'common.label.donutChart', defaultMessage: 'Donut Chart' }), value: ChartType.DONUT, icon: 'donut-chart' },
      { label: LanguageUtil.get({ id: 'common.label.indicatorChart', defaultMessage: 'Indicator Chart' }), value: ChartType.INDICATOR, icon: 'chart' },
      {
        label: LanguageUtil.get({ id: 'common.label.barVerticalStacked', defaultMessage: 'Bar Vertical Stacked' }),
        value: ChartType.BAR_VERTICAL_STACKED,
        icon: 'bar-vertical-chart',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.barVerticalRowed', defaultMessage: 'Bar Vertical Rowed' }),
        value: ChartType.BAR_VERTICAL_ROWED,
        icon: 'bar-vertical-chart',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.barHorizontalStacked', defaultMessage: 'Bar Horizontal Stacked' }),
        value: ChartType.BAR_HORIZONTAL_STACKED,
        icon: 'bar-horizontal-chart',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.barHorizontalRowed', defaultMessage: 'Bar Horizontal Rowed' }),
        value: ChartType.BAR_HORIZONTAL_ROWED,
        icon: 'bar-horizontal-chart',
      },
    ];
  };

  private getChartOptions() {
    const {
      chart: { chart },
    } = this.props;
    return (
      <div className={'flex gap-x-2 items-center justify-around'}>
        <LegendOptionPanel />
      </div>
    );
  }

  private onChangeChartType = (e: FormicaSelectBoxItem) => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
      changeChartResponse,
    } = this.props;
    if (e.value == ChartType.INDICATOR) {
      chartEditorOptions.segmentItem = null;
      chartEditorOptions.breakdown = null;
    }
    changeChartEditorOptions(chartEditorOptions);
    this.setChartType(e.value as ChartType);
    if (e.value == ChartType.INDICATOR) {
      changeChartResponse(undefined);
    }
  };
}

class State {}

interface Props extends ReduxProps, FormicaProps {
  simulateChart: () => void;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
  isUpdate: state.chart.isUpdate,
  page: state.page as PageState,
  auth: state.auth as AuthState,
});

const mapDispatchToProps = {
  changeChart,
  changeChartEditorOptions,
  changeIsUpdate,
  enterComponent,
  leaveComponent,
  clearChart,
  setExpressionVariables,
  changeChartResponse,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ChartSettingsContainer));
